/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { IMaintenanceModeInfo } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class MaintenanceModeApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Maintenance Mode API
   * @name GetMaintenanceMode
   * @summary Get the currently set maintenance mode information
   * @request GET:/api/maintenance
   * @response `200` `IMaintenanceModeInfo`
   */
  getMaintenanceMode = (params: RequestParams = {}) =>
    this.request<IMaintenanceModeInfo, any>({
      path: `/api/maintenance`,
      method: "GET",
      format: "json",
      ...params,
    });
}
